
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import defineBuiltIn$1 from './define-built-in.js';

var defineBuiltIn = defineBuiltIn$1;

var defineBuiltIns = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};

export { defineBuiltIns as default };
//# sourceMappingURL=define-built-ins.js.map
